import { DiscountInfo, SetDiscount } from './typings'

export const setDiscountActionCreator = (
  payload: DiscountInfo,
): SetDiscount => ({
  type: 'referrals/setDiscount',
  payload,
})
